// ✅ DSPM SLICE (same structure as CSPM slice)
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dspmService } from "@/src/services/DSPM/dspmService";

export interface DSPMScanState {
  isScanning: boolean;
  status: "idle" | "scanning" | "completed" | "failed";
  scan_id: string | null;
  scanError: string | null;
  lastScannedDataStoreId: string | null;
}

const initialState: DSPMScanState = {
  isScanning: false,
  status: "idle",
  scan_id: null,
  scanError: null,
  lastScannedDataStoreId: null,
};

// ---------------------------------------------------
//  START DSPM SCAN
// ---------------------------------------------------
export const startDSPMScan = createAsyncThunk(
  "dspmScan/startScan",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await dspmService.scanDataStore(data);

      // Check if the API response indicates failure
      if (response && response.success === false) {
        return rejectWithValue(response.message || "Scan failed");
      }

      if (response.success) {
        return {
          dataStoreId: data._id,   // IMPORTANT for UI row scanning
          scan_id: response.scan_id,
        };
      }

      return rejectWithValue(response.message);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "DSPM scan failed");
    }
  }
);

// ---------------------------------------------------
//  SLICE
// ---------------------------------------------------
const dspmScanSlice = createSlice({
  name: "dspmScan",
  initialState,
  reducers: {
    resetDSPMScanState: () => initialState,
  },

  extraReducers: (builder) => {
    builder
      .addCase(startDSPMScan.pending, (state, action) => {
        state.isScanning = true;
        state.status = "scanning";
        state.scanError = null;
        state.lastScannedDataStoreId = action.meta.arg._id;
      })

      .addCase(startDSPMScan.fulfilled, (state, action) => {
        state.isScanning = false;
        state.status = "completed";
        state.scan_id = action.payload.scan_id;
        state.lastScannedDataStoreId = action.payload.dataStoreId;
      })

      .addCase(startDSPMScan.rejected, (state, action) => {
        state.isScanning = false;
        state.status = "failed";
        state.scanError = action.payload as string || action.error.message || "DSPM scan failed";
        state.lastScannedDataStoreId = null;
      });
  },
});

export const { resetDSPMScanState } = dspmScanSlice.actions;
export default dspmScanSlice.reducer;
